module.exports = __webpack_public_path__ + "img/ttgh.d6b8d987.jpg";